// @flow
import R from "ramda"
import type { Dispatch } from "redux"

import { saveAncillaries } from "../persistStoreTools"
import type { StoredAncillaries } from "../persistStoreTools"
import type { State } from "booking/services/types"
import { getServicePackages } from "booking/services/servicePackages/reducer"
import { getAdditionalServices } from "booking/services/additionalServices/reducer"
import { getBookingToken } from "booking/services/states/reducer"

const saveAddedAncillaries = () => (dispatch: Dispatch<any>, getState: () => State) => {
  const store = getState()

  const additionalServices = getAdditionalServices(store)
  const servicePackages = getServicePackages(store)
  const bookingToken = getBookingToken(store)

  const addedServices = R.pipe(
    R.pickBy,
    R.keys,
  )(service => service.isAdded, additionalServices)

  const ancillaries: StoredAncillaries = {
    additionalServices: addedServices,
    addPaidCheckin: additionalServices.paidCheckin?.is_added,
    chosenServicePackage: servicePackages.chosenServicePackage,
    bookingToken,
  }

  saveAncillaries(ancillaries)
}

export default saveAddedAncillaries
